$(document).ready(function () {
  const maxDuration = 10000; // 10 seconds
  const startTime = Date.now();

  const interval = setInterval(() => {
    const widgetEl = document.querySelector('recharge-subscription-widget');
    if (!widgetEl) return;

    const shadow = widgetEl.shadowRoot;
    if (!shadow) return;

/*    const style = document.createElement('style');
    style.setAttribute('data-injected', 'true');
    style.textContent = `
      button.recharge-button ._15b7gxl0 ._15b7gxl0 ._15b7gxl0 {
        padding: 3px !important;
      }`;
    shadow.appendChild(style);
*/    

    const rootElement = shadow.querySelector('.rc-widget__root');
    if (rootElement) {
      // Inject base styles once
      if (!shadow.querySelector('style[data-injected]')) {
        const style = document.createElement('style');
        style.setAttribute('data-injected', 'true');
        style.textContent = `
          .rc-benefits__list li {
            margin: 0 !important;
          }

          .rc-plans-dropdown__select,
          .rc-plans__label {
            font-size: 16px !important;
          }

          .rc-purchase-option__label {
            padding: 12px 20px !important;
            flex-direction: row !important;
            justify-content: space-between !important;
          }

          .rc-purchase-option__selector {
            /*font-size: 16px !important;*/
            padding: 0 !important;
          }
          .rc-purchase-option__badge {
            position: unset !important;
            margin-right: auto !important;
            margin-left: 20px !important;
          }

                .rc-purchase-option__subscription {
                  overflow: hidden !important;
                  max-height: 48px !important;
                  transition: max-height 0.5s 0.1s !important;
                }
              .rc-purchase-option[rc-selected] {
                  max-height: 300px !important;
                }
          
    
        `;
        shadow.appendChild(style);
        console.log("✅ Base styles injected into recharge-subscription-widget");
      }

      // ✅ Also insert badge on load
      (function insertBadgeOnLoad() {
        const badge = shadow.querySelector('.rc-purchase-option__badge');
        const selectors = shadow.querySelectorAll('.rc-purchase-option__selector');
        
        if (!badge) {
          console.warn("❌ .rc-purchase-option__badge not found (on load)");
        } else if (selectors.length < 2) {
          console.warn("❌ Not enough .rc-purchase-option__selector elements found (on load)");
        } else {
          selectors.forEach(selector => {
            if (!selector.classList.contains('rc-purchase-option__selector_subscription')) {
              const parent = selector.parentElement;
              if (!parent) return;

              if (badge.parentElement !== parent || badge.previousElementSibling !== selector) {
                parent.insertBefore(badge, selector.nextSibling);
                console.log('✅ .rc-purchase-option__badge inserted on load after non-subscription selector');
              }
            }
          });
        }
      })();

      // Add click handler (once) for the subscription label
      const label = shadow.querySelector('.rc-purchase-option__subscription');
      if (label && !label.hasAttribute('data-click-bound')) {
        label.setAttribute('data-click-bound', 'true');

        label.addEventListener('click', () => {
          console.log('🖱️ .rc-purchase-option__subscription clicked');

          setTimeout(() => {
            // === Handle rc-benefits ===
            const rcBenefits = shadow.querySelector('rc-benefits');
            if (rcBenefits?.shadowRoot && !rcBenefits.shadowRoot.querySelector('style[data-benefits-style]')) {
              const style = document.createElement('style');
              style.setAttribute('data-benefits-style', 'true');
              style.textContent = `
                .rc-benefits__list li,
                .rc-benefits__list li p {
                  margin: 0 !important;
                  font-size: 15px !important;
                }


                
              `;
              rcBenefits.shadowRoot.appendChild(style);
              console.log('✅ CSS injected into rc-benefits shadow DOM');
            }

            // === Handle rc-selling-plans ===
            const rcPlans = shadow.querySelector('rc-selling-plans');
            if (rcPlans?.shadowRoot && !rcPlans.shadowRoot.querySelector('style[data-selling-style]')) {
              const style = document.createElement('style');
              style.setAttribute('data-selling-style', 'true');
              style.textContent = `
                .rc-plans-dropdown,
                .rc-plans-dropdown__select {
                  font-size: 15px !important;
                }
                .rc-purchase-option__badge {
                    position: unset !important;
                    margin-right: auto !important;
                    margin-left: 20px !important;
                }
              `;
              rcPlans.shadowRoot.appendChild(style);
              console.log('✅ CSS injected into rc-selling-plans shadow DOM');
            }

            // ✅ Also insert badge again after click (in case DOM changed)
            const badge = shadow.querySelector('.rc-purchase-option__badge');
            const selectors = shadow.querySelectorAll('.rc-purchase-option__selector');
            
            if (!badge) {
              console.warn("❌ .rc-purchase-option__badge not found (on click)");
            } else if (selectors.length < 2) {
              console.warn("❌ Not enough .rc-purchase-option__selector elements found (on click)");
            } else {
              selectors.forEach(selector => {
                if (!selector.classList.contains('rc-purchase-option__selector_subscription')) {
                  const parent = selector.parentElement;
                  if (!parent) return;

                  if (badge.parentElement !== parent || badge.previousElementSibling !== selector) {
                    parent.insertBefore(badge, selector.nextSibling);
                    console.log('✅ .rc-purchase-option__badge inserted after non-subscription selector (on click)');
                  }
                }
              });
            }

          }, 150); // wait for dynamic render
        });
      }

      clearInterval(interval); // once everything is set up
    }

    if (Date.now() - startTime > maxDuration) {
      clearInterval(interval);
      console.warn('⏰ Timeout: Recharge widget not ready in time');
    }
  }, 100);
});


$(document).ready(function() {
  $('#ruffruff-table-of-contents').appendTo('#table-contents');
});

document.addEventListener("touchstart", function() {},false);

var cart_config = document.getElementById('cart-config');
var cart_config_ = JSON.parse(cart_config.innerHTML || '{}');
Shopify.money_format = cart_config_.money_format

var $window = $(window);

$window.on('resize', function(){
}).trigger('resize');


$(document).ready(function() {
  // Move subscription widget above add to cart button
  $('.recharge-subscription-widget').appendTo('.recharge-widget');
  
  $('.trigger-addtocart').on('click', function() {
    $(this).addClass('loading');
    $('.product-add .product__add-button').click();
  });

  $('.trigger-klaviyo-notify').on('click', function() {
    $(this).addClass('loading');
    $('.klaviyo-notify-btn.klaviyo-bis-trigger')[0].click();
  });

  setTimeout(function() {
    window.dispatchEvent(new Event('resize'));
  }, 1000)

  $('.atc-btn-sticky').click(function() {
    console.log('clicked')
    $(this).text('Adding...')
    $('.product-add #addToCart').click()
  });

  $('.product-info-tooltip .close').click(function() {
    $(this).closest('.product-info-tooltip').removeClass('active');
  });

  $('body').on('click', '.tooltip', function() {
    $(this).next('.product-info-tooltip').addClass('active')
  });
  
  $('body').on('click','.tooltip-hover .product-info-tooltip.active', function(e) {
    if (e.target !== this)
      return;
    $('.product-info-tooltip.active').removeClass('active');
  });

  $('.product-tabs .tab').click(function() {
    $(this).closest('.product-detail-tabs').find('.active').removeClass('active');
    var tab = $(this).attr('tab')
    $(this).addClass('active');
    $(this).closest('.product-detail-tabs').find('.tab-content[content="' + tab + '"]').addClass('active')
  })

  $('.cart-links__link-search').click(function(e) {
    e.preventDefault();
    $('.header-search-overlay').fadeIn();
    $('.announcement-bar__search-input').focus();
  });

  $('.search-bar__close').click(function(e) {
    e.preventDefault();
    $('.header-search-overlay').fadeOut();
  });

  $('.collection-tab-list .tab').click(function() {
    var container = $(this).closest('.collection-tabs-section');
    container.find('.tab').removeClass('active');
    $(this).addClass('active')
    var tab = $(this).attr('tab-name');

    container.find('.collection-product-grid .product-grid').removeClass('show');
    container.find('.collection-product-grid .product-grid[tab-name="' + tab + '"]').addClass('show');

    if(tab == 'DOG PRODUCTS') {
      $(this).closest('.collection-tabs-section').find('.tab-name-selector').text('Dog Supplements');
    }
    else {
      $(this).closest('.collection-tabs-section').find('.tab-name-selector').text('Cat Supplements');
    }
  });

  $('.btn-form-submit').on('click', function() {
    $('#customer_login').removeAttr('data-login-with-shop-sign-in')
    $('#customer-login [name="checkout_url"]').remove();
    $('.btn-form-submit-hidden').click();
  });

});

$(document).ready(function() {
  
  if($(window).width() > 768) {
    $('body').on('mouseenter', '.tooltip-hover .tooltip',function() {
      var tooltipContainer = $(this).parent().find('.product-info-tooltip');
      tooltipContainer.addClass('active');
    });
    $('body').on('mouseleave', '.tooltip-hover',function() {
      $(this).find('.product-info-tooltip').removeClass('active')
    });
  }

  $('[name="selling_plan-1"]').on('change', function() {
    if($('[name="selling_plan-1"][value="subscription"]:checked').length > 0) {
      $('.afterpay-wrapper').addClass('active');
    }
    else {
      $('.afterpay-wrapper').removeClass('active');
    }
  });

  $('.most-popular-variant label').click();

  $('body').on('change', '.product-grid-addtocart select', function() {
    var optionPrice = $(this).find('option:selected', this).attr('variant-price');
    $(this).closest('.product-index').find('.product-info .price').html(optionPrice)
  })
  
});


// Tabs Javascript Script 

class TabContainer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const tabButtons = this.querySelectorAll(".tab-button");

    tabButtons.forEach((tabButton) => {
      const handleTabInteraction = (event) => {
        event.stopPropagation();
        const currentTabContentId = tabButton.getAttribute("data-tab-content");
        const currentTitleContentId = tabButton.getAttribute("data-tab-title");
        const currentTabContent = this.querySelector(currentTabContentId);
        const currentTabTitle = this.querySelector(currentTitleContentId);

        tabButtons.forEach((button) => {
          button.classList.remove("is-active");
        });

        tabButton.classList.add("is-active");

        this.querySelectorAll(".tab-content").forEach((tabContent) => {
          tabContent.classList.remove("is-active");
        });

        currentTabContent.classList.add("is-active");


        this.querySelectorAll(".section--title").forEach((titleContent) => {
          titleContent.classList.remove("is-active");
        });

        currentTabTitle.classList.add("is-active");
        
      };

      tabButton.addEventListener("click", handleTabInteraction);
      tabButton.addEventListener("touchstart", handleTabInteraction);
    });

  }
}

customElements.define("tab-container", TabContainer);


// Custom Product Form

class CustomProductForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.card = this.querySelector(".item-wrapper");
    this.variantButtons = this.querySelectorAll(".variant-button");
    this.atcButton = this.querySelector("button[type='submit']");

    if (!this.variantButtons.length || !this.atcButton) return;

    this.selectedVariantId = this.card.getAttribute("data-selected-variant");

    this.bindVariantButtons();
    this.bindAddToCart();
  }

  bindVariantButtons() {
    this.variantButtons.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();

        this.variantButtons.forEach((b) => b.classList.remove("selected"));
        btn.classList.add("selected");

        const variantId = btn.dataset.variant;
        if (variantId) {
          this.selectedVariantId = variantId;

          if (this.card) {
            this.card.setAttribute("data-selected-variant", variantId);
          }
        } else {
          console.warn("⚠️ No data-variant found on clicked button");
        }
      });
    });
  }

  bindAddToCart() {
    this.atcButton.addEventListener("click", (e) => {
      e.preventDefault();

      // if (!this.selectedVariantId) {
      //   console.warn("⚠️ No variant selected yet!");
      //   return;
      // }

      const body = JSON.stringify({
        id: this.selectedVariantId,
        quantity: 1,
      });

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body,
      })
        .then((res) => res.json())
        .then((data) => {
          // console.log("🛒 Added to cart:", data);
          window.location.href = "/cart";
        })
        .catch((err) => console.error("Add to cart error:", err));
    });
  }
}

customElements.define("custom-product-form", CustomProductForm);



